import { ClearwaterTransaction, ExternalTransaction } from '@helios/common-api'
import { HeliosServerSideRequest } from '@helios/server-side-util'
import { Observable } from 'rxjs'
import {
  ExportExcelRequest,
  ExternalTransactionSetValues,
  TransactionAvailableRestrictedColumns,
} from '../models/external-transaction'
import { ExternalTransactionsActionResponse } from '../models/external-transactions-action.model'
import { GenericTxSummary } from '@helios/generic-components'

export abstract class ExternalTransactionsService {
  abstract getTransactions(
    request: HeliosServerSideRequest<ExternalTransaction>,
    cacheLoaded$: Observable<boolean>,
  ): Promise<ExternalTransaction[]>

  abstract getTransactionsByIds(
    extTxIds: string[],
    fields?: string[],
  ): Promise<ExternalTransaction[]>

  abstract getExternalTransactionSetValues(): Observable<ExternalTransactionSetValues>

  abstract hold(
    extTrans: ExternalTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract unhold(
    extTrans: ExternalTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract ignore(
    extTrans: ExternalTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract unignore(
    extTrans: ExternalTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract match(
    extTrans: ExternalTransaction[],
    cwTrans: ClearwaterTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract manyToManyMatch(
    extTrans: ExternalTransaction[],
    cwTrans: ClearwaterTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract matchUsingExternal(
    extTran: ExternalTransaction,
    cwTrans: ClearwaterTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract unmatch(
    extTrans: ExternalTransaction[],
  ): Observable<ExternalTransactionsActionResponse>

  abstract exportToExcel(request: ExportExcelRequest): Observable<Blob>

  abstract getAllExtTransactionsIds(
    request: HeliosServerSideRequest<ExternalTransaction>,
  ): Promise<string[]>

  abstract getTransactionSummaries(
    request: HeliosServerSideRequest<ExternalTransaction>,
  ): Promise<GenericTxSummary>

  abstract getAvailableRestrictedColumns(): Observable<
    TransactionAvailableRestrictedColumns[]
  >
}
